// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"44ff8c9c","653":"c60a4614"}[chunkId] + ".chunk.js";
};